//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            22nd January 2018
//  * @type            Survey Create Component File
//  * @description -   This file renders the html and functionality for creating a default survey in app.
<template>
  <v-wait for="creating survey">
    <!-- <div id="loadingdiv">
      <img src="../assets/images/loader.gif">
    </div> -->
    <div id="loadingDiv" class="loadingDiv_analytics">
        <div class="loadersec">
          <div class="loader"></div>
        </div>
    </div>
  </v-wait>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateSurvey",
  data() {
    return {
      // msg: 'Welcome to Your Vue.js App',
      // setting:[],
      data: []
    };
  },
  computed: {
    ...mapGetters("LeftSidebarCreate", ["all"])
  },
  watch: {
    all: {
      handler(newVal) {
        if (this.all.flag == 1) {
          this.$router.push({
            name: "Dashboard",
            params: { id: this.all.md5_in_survey_id }
          });
          this.$session.set("in_survey_Id", this.all.in_survey_Id);
          // this.$awn.success('Survey created')
        } else if (this.all.flag == 0) {
          console.log(this.all);
          // this.$awn.alert(this.all.msg)
        } else {
          // this.$awn.alert(this.all.msg)
        }
      }
    }
  },
  methods: {
    ...mapActions("LeftSidebarCreate", [
      "fetchData",
      "fetchDesignData",
      "getSurveyById"
    ])
  },
  async created() {
    this.$wait.start("creating survey");
    this.data = this.$session.getAll();
    await this.fetchData(this.data);
    this.$wait.end("creating survey");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CreateSurvey.vue